import { IconComponentProps, RaindropIcon, SnowflakeIcon } from '../../components/icons/Icons.tsx';
import { IPrecipitationType } from '../model/IPrecipitationType.ts';

export const PrecipitationIcon: React.FC<IconComponentProps & {precipitationType: IPrecipitationType}> = ({ precipitationType, ...props }) => {
    if (precipitationType === 'snow') {
        return (
            <SnowflakeIcon {...props} />
        );
    }
    return (
        <RaindropIcon {...props} />
    );
};
